import type { IconData } from '@stacksjs/iconify-core'

export const diamond2Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.938 4a4.89 4.89 0 0 0-4.293 2.557L1.1 16.753a4.93 4.93 0 0 0 .756 5.747L21.16 42.78a3.92 3.92 0 0 0 5.68 0L46.145 22.5a4.93 4.93 0 0 0 .757-5.747L41.355 6.557A4.89 4.89 0 0 0 37.062 4zm-.779 4.468A.89.89 0 0 1 10.938 8H16.2l-2.323 9.594H5.195zM6.515 21.594l12.604 13.24l-5.11-13.24zm11.78 0l5.708 14.788l5.705-14.788zm15.7 0l-5.104 13.23l12.594-13.23zm8.81-4h-8.679L31.803 8h5.26c.318 0 .618.175.778.468zm-12.795 0H17.993L20.316 8h7.372z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default diamond2Remix
